const CALL_FILTERS_PARAMETERS = {
    DEFAULT: 1,
    TRAFFIC_SOURCE: 2,
    CALL_FLOW_PARAMETERS: 3,
    CUSTOM_PARAMETERS: 4,
    CALLER_IDENTITY: 5,
    RTB: 6,
    CALL_FLOW: 7,
    HTTP_ROUTER: 8,
    SESSION_DATA: 9,
    SIP_HEADERS: 10,
}

export {
    CALL_FILTERS_PARAMETERS,
}
